/**
 * What a saved SQL script is labelled with in the new-query picker (card 2d532772).
 *
 * The sidecar stores the tab's `dbName`. For MySQL / MariaDB that IS the
 * database. For PostgreSQL the tree's "databases" are the SCHEMAS of the one
 * database the connection opens, so a script saved on `public` was labelled
 * "public" — true, but not where it lives. PostgreSQL scripts now read
 * `"<database>" · <schema>`, the database taken from the saved connection.
 *
 * @param {{ engine?: string, dbName?: string|null, connId?: string }|null} meta
 * @param {Record<string, string>} connDatabases  connId → the connection's database
 * @returns {string} '' when the script has no binding
 */
export function dbScriptTargetLabel(meta, connDatabases = {}) {
  if (!meta?.dbName) return '';
  if (meta.engine === 'postgres') {
    const database = connDatabases[meta.connId];
    return database ? `"${database}" · ${meta.dbName}` : `schema ${meta.dbName}`;
  }
  return `"${meta.dbName}"`;
}
